import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement> & { size?: number }

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
})

export function RabbitMark({ size = 42, ...props }: IconProps) {
  return (
    <svg {...base(size)} viewBox="0 0 48 48" {...props}>
      <path d="M17.4 18.2C11.2 8.5 12.6 3 16 3c3.7 0 6.1 8 7 14.1" fill="currentColor" opacity=".35" />
      <path d="M28.5 17.4C29.6 7.2 32 3 35.1 4c3.7 1.2 2.4 9.9-1.3 16.4" fill="currentColor" opacity=".52" />
      <path d="M39 30.6c0 8.1-6.3 13.4-15.2 13.4S9 38.7 9 30.6s6.1-14 14.8-14S39 22.5 39 30.6Z" fill="currentColor" />
      <circle cx="18.2" cy="29.1" r="1.7" fill="white" />
      <circle cx="31.4" cy="29.1" r="1.7" fill="white" />
      <path d="M22.3 34.1c1.1 1 2.9 1 4 0" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M24.3 32v2.7" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
      <path d="m21.8 31.5 2.5 1.3 2.5-1.3" fill="white" />
    </svg>
  )
}

export function HomeIcon({ size = 22, ...props }: IconProps) {
  return <svg {...base(size)} {...props}><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1V10Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /></svg>
}

export function PracticeIcon({ size = 22, ...props }: IconProps) {
  return <svg {...base(size)} {...props}><path d="M6 17.5h12M8 14l-4-2 4-2m8 4 4-2-4-2M7 6h10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
}

export function SettingsIcon({ size = 22, ...props }: IconProps) {
  return <svg {...base(size)} {...props}><path d="M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z" stroke="currentColor" strokeWidth="1.8" /><path d="m19 13.4 1.5 1.2-2 3.5-1.8-.7a7.5 7.5 0 0 1-2.3 1.3l-.3 1.9h-4l-.3-1.9a7.5 7.5 0 0 1-2.4-1.3l-1.8.7-2-3.5 1.5-1.2a7.7 7.7 0 0 1 0-2.8L3.6 9.4l2-3.5 1.8.7a7.5 7.5 0 0 1 2.4-1.3l.3-1.9h4l.3 1.9a7.5 7.5 0 0 1 2.3 1.3l1.8-.7 2 3.5-1.5 1.2a7.7 7.7 0 0 1 0 2.8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /></svg>
}

export function ArrowIcon({ size = 20, ...props }: IconProps) {
  return <svg {...base(size)} {...props}><path d="M5 12h14m-5-5 5 5-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
}

export function BackIcon({ size = 20, ...props }: IconProps) {
  return <svg {...base(size)} {...props}><path d="M19 12H5m5-5-5 5 5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
}

export function SoundIcon({ size = 20, ...props }: IconProps) {
  return <svg {...base(size)} {...props}><path d="M5 10v4h3l4 3V7L8 10H5Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /><path d="M15 9.2a4 4 0 0 1 0 5.6M17.5 7a7 7 0 0 1 0 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
}

export function CheckIcon({ size = 20, ...props }: IconProps) {
  return <svg {...base(size)} {...props}><path d="m5 12 4 4L19 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" /></svg>
}

export function LockIcon({ size = 18, ...props }: IconProps) {
  return <svg {...base(size)} {...props}><rect x="5" y="10" width="14" height="11" rx="3" stroke="currentColor" strokeWidth="1.8" /><path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="1.8" /></svg>
}

export function KeyboardIcon({ size = 20, ...props }: IconProps) {
  return <svg {...base(size)} {...props}><rect x="2.5" y="5" width="19" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.8" /><path d="M6 9h.01M9 9h.01M12 9h.01M15 9h.01M18 9h.01M6 12.5h.01M9 12.5h.01M12 12.5h.01M15 12.5h.01M18 12.5h.01M7.5 16h9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
}

export function CloseIcon({ size = 20, ...props }: IconProps) {
  return <svg {...base(size)} {...props}><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
}
